import styled from '@emotion/styled';
import Skeleton from '@mui/material/Skeleton';

import { customPalette } from '../../styles/theme';

export const CardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: flex-start;
  padding-top: 24px;
`;

export const SkeletonCardContainer = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 340px;
`;

export const SkeletonAvatar = styled(Skeleton)`
  margin-bottom: 24px;
`;

export const SkeletonText = styled(Skeleton)`
  margin-bottom: 16px;
`;

export const NoContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
`;

export const NoContactsIcon = styled.div`
  svg {
    font-size: 64px;
    color: ${customPalette.grey[300]};
    margin-bottom: 16px;
  }
`;

export const NoContactsMessage = styled.div`
  font-size: 18px;
`;
